<template>
    <div :class="$store.state.bgClass">
        <router-view/>
        <div class="bthover">
            <div class="route_box">
                <el-tooltip class="item" v-if="userPower.isIndex==1" effect="dark" content="首页" placement="top-start">
                    <div @click="gorouter(0,userPower.isIndex)" class="gopage_box">
                        <img v-if="index==0" src="../assets/page1_2.png"/>
                        <img v-else src="../assets/page1_1.png"/>
                        <div v-if="index==0">首页</div>
                    </div>
                </el-tooltip>
                <el-tooltip class="item" v-if="userPower.isVideo==1" effect="dark" content="视频监控" placement="top-start">
                    <div @click="gorouter(1,userPower.isVideo)" class="gopage_box">
                        <img v-if="index==1" src="../assets/page2_2.png"/>
                        <img v-else src="../assets/page2_1.png"/>
                        <div v-if="index==1">视频监控</div>
                    </div>
                </el-tooltip>
                <el-tooltip class="item" v-if="userPower.isEquipment==1" effect="dark" content="机械设备"
                            placement="top-start">
                    <div @click="gorouter(14,userPower.isEquipment)" class="gopage_box">
                        <img v-if="index==14" src="../assets/page14_2.png"/>
                        <img v-else src="../assets/page14_1.png"/>
                        <div v-if="index==14">机械设备</div>
                    </div>
                </el-tooltip>
                <!--<el-tooltip class="item" effect="dark" content="塔吊监控" placement="top-start">
                    <div @click="gorouter(2)" class="gopage_box">
                        <img v-if="index==2" src="../assets/page3_2.png" />
                        <img v-else src="../assets/page3_1.png" />
                        <div v-if="index==2">塔吊监控</div>
                    </div>
                </el-tooltip>-->
                <el-tooltip class="item" v-if="userPower.isEnvironment==1" effect="dark" content="环境监测"
                            placement="top-start">
                    <div @click="gorouter(3,userPower.isEnvironment)" class="gopage_box">
                        <img v-if="index==3" src="../assets/page4_2.png"/>
                        <img v-else src="../assets/page4_1.png"/>
                        <div v-if="index==3">环境监测</div>
                    </div>
                </el-tooltip>
                <el-tooltip class="item" v-if="userPower.isSecurity==1" effect="dark" content="安全管理"
                            placement="top-start">
                    <div @click="gorouter(12,userPower.isSecurity)" class="gopage_box">
                        <img v-if="index==12" src="../assets/page13_2.png"/>
                        <img v-else src="../assets/page13_1.png"/>
                        <div v-if="index==12">安全管理</div>
                    </div>
                </el-tooltip>
                <el-tooltip class="item" v-if="userPower.isQuality==1" effect="dark" content="质量管理"
                            placement="top-start">
                    <div @click="gorouter(4,userPower.isQuality)" class="gopage_box">
                        <img v-if="index==4" src="../assets/page5_2.png"/>
                        <img v-else src="../assets/page5_1.png"/>
                        <div v-if="index==4">质量管理</div>
                    </div>
                </el-tooltip>
                <el-tooltip class="item" v-if="userPower.isLabou==1" effect="dark" content="劳务分析" placement="top-start">
                    <div @click="gorouter(5,userPower.isLabou)" class="gopage_box">
                        <img v-if="index==5" src="../assets/page6_2.png"/>
                        <img v-else src="../assets/page6_1.png"/>
                        <div v-if="index==5">劳务分析</div>
                    </div>
                </el-tooltip>
                <el-tooltip class="item" v-if="userPower.isSpeed==1" effect="dark" content="进度管理" placement="top-start">
                    <div @click="gorouter(6,userPower.isSpeed)" class="gopage_box">
                        <img v-if="index==6" src="../assets/page7_2.png"/>
                        <img v-else src="../assets/page7_1.png"/>
                        <div v-if="index==6">进度管理</div>
                    </div>
                </el-tooltip>
                <!--<el-tooltip class="item" effect="dark" content="BIM模型" placement="top-start">
                    <div @click="gorouter(7)" class="gopage_box">
                        <img v-if="index==7" src="../assets/page8_2.png" />
                        <img v-else src="../assets/page8_1.png" />
                        <div v-if="index==7">BIM模型</div>
                    </div>
                </el-tooltip>-->
                <!--<el-tooltip class="item" effect="dark" content="能源管理" placement="top-start">
                    <div @click="gorouter(8)" class="gopage_box">
                        <img v-if="index==8" src="../assets/page9_2.png" />
                        <img v-else src="../assets/page9_1.png" />
                        <div v-if="index==8">能源管理</div>
                    </div>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="混凝土温度" placement="top-start">
                    <div @click="gorouter(9)" class="gopage_box">
                        <img v-if="index==9" src="../assets/page10_2.png" />
                        <img v-else src="../assets/page10_1.png" />
                        <div v-if="index==9">混凝土温度</div>
                    </div>
                </el-tooltip>-->
                <!--<el-tooltip class="item" effect="dark" content="水位监测" placement="top-start">
                    <div @click="gorouter(10)" class="gopage_box">
                        <img v-if="index==10" src="../assets/page11_2.png" />
                        <img v-else src="../assets/page11_1.png" />
                        <div v-if="index==10">水位监测</div>
                    </div>
                </el-tooltip>-->
                <!--<el-tooltip class="item" effect="dark" content="设计管理" placement="top-start">
                    <div @click="gorouter(11)" class="gopage_box">
                        <img v-if="index==11" src="../assets/page12_2.png" />
                        <img v-else src="../assets/page12_1.png" />
                        <div v-if="index==11">设计管理</div>
                    </div>
                </el-tooltip>-->
                <el-tooltip class="item" v-if="userPower.isPolice==1" effect="dark" content="报警统计"
                            placement="top-start">
                    <div @click="gorouter(13,userPower.isPolice)" class="gopage_box">
                        <img v-if="index==13" src="../assets/page15_2.png"/>
                        <img v-else src="../assets/page15_1.png"/>
                        <div v-if="index==13">报警统计</div>
                    </div>
                </el-tooltip>
                <el-tooltip class="item" v-if="userPower.isAI==1" effect="dark" content="AI识别分析" placement="top-start">
                    <div @click="gorouter(15,userPower.isAI)" class="gopage_box">
                        <img v-if="index==15" src="../assets/page16_2.png"/>
                        <img v-else src="../assets/page16_1.png"/>
                        <div v-if="index==15">AI识别分析</div>
                    </div>
                </el-tooltip>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from 'vuex'
    import heads from "@/components/header.vue"
    import {socketInit} from '@/axios/config'

    export default {
        data() {
            return {
                flag: false,
                index: 0,
                userPower: {},
                Notifys: {},//报警提示框 不重复提醒  点击关闭提示框
            }
        },
        components: {
            heads
        },
        computed: {
            ...mapState(['addlable']),
        },
        created() {
            if (this.$route.name == 'home') {
                this.index = 0
            } else if (this.$route.name == 'towercrane') {
                this.index = 2
            } else if (this.$route.name == 'environment') {
                this.index = 3
            } else if (this.$route.name == 'security') {
                this.index = 12
            } else if (this.$route.name == 'quality') {
                this.index = 4
            } else if (this.$route.name == 'laborAnalysis') {
                this.index = 5
            } else if (this.$route.name == 'speed') {
                this.index = 6
            } else if (this.$route.name == 'BIM') {
                this.index = 8
            } else if (this.$route.name == 'waterlevel') {
                this.index = 11
            } else if (this.$route.name == 'callPolice') {
                this.index = 13
            } else if (this.$route.name == 'crane') {
                this.index = 14
            } else if (this.$route.name == 'AiAnalysis') {
                this.index = 15
            }
            this.getProjectId()
            this.jurisdiction()
        },
        mounted() {
            //this.resetScreenSize()
            //初始化消息
            socketInit(this);
            //
            //监听自定义消息处理
            //塔机
            //升降机
            this.$bus.$on('MONITOR_EQUI_WARN', (data) => {
                console.log(data)
                this.showNotify(JSON.parse(data));
            })
        },
        methods: {
            showNotify(data) {
                var that = this;
                var one = this.$notify({
                    type: 'warning',
                    duration: 0,
                    dangerouslyUseHTMLString: true,
                    customClass: 'notify-class',
                    title: data.title,
                    message: '<span>' + data.msgContent + '</span>',
                    onClick: function () {
                        that.notifyClick(data.data)
                    }
                });
                this.Notifys[data.data] = one;
            },
            notifyClick(id) {
                if (this.$route.path != "/index/crane") {
                    this.$router.push("/index/crane")
                }
                this.index = 14;
                if (this.Notifys[id]) {
                    this.Notifys[id].close();
                    delete this.Notifys[id];
                }
            },
            jurisdiction() {
                this.getAxios('/adminRoleMenuDp/getByUser', {}, 'json').then(res => {
                    this.userPower = res.data.data.construction
                }).catch(err => {
                });
            },
            getProjectId() {
                this.postAxios('/adminUser/queryLoginUser', {
                    1: 1
                }).then(res => {
                    this.$store.state.projectId = res.data.projectId

                }).catch(err => {
                })
            },
            goBMI(id) {
                this.$router.push({
                    name: 'BIM',
                    params: {
                        id: id
                    }
                })
            },
            gorouter(val, item) {
                if (item == 1) {
                    this.index = val
                    if (val == 0) {
                        this.$router.push("/index/home")
                    } else if (val == 1) {
                        this.$router.push("/index/monitor")
                    } else if (val == 2) {
                        this.$router.push("/index/towercrane")
                    } else if (val == 3) {
                        this.$router.push("/index/environment")
                    } else if (val == 4) {
                        this.$router.push("/index/quality")
                    } else if (val == 5) {
                        this.$router.push("/index/laborAnalysis")
                    } else if (val == 6) {
                        this.$router.push("/index/speed")
                    } else if (val == 12) {
                        this.$router.push("/index/security")
                    } else if (val == 10) {
                        this.$router.push("/index/waterlevel")
                    } else if (val == 7) {
                        this.$router.push("/index/BIM")
                    } else if (val == 13) {
                        this.$router.push("/index/callPolice")
                    } else if (val == 14) {
                        this.$router.push("/index/crane")
                    } else if (val == 15) {
                        this.$router.push("/index/AiAnalysis")
                    }
                } else {
                    this.$message({
                        message: '暂无权限,请联系管理员',
                        type: 'warning'
                    });
                }

            },
            mouseOver() {
                this.flag = true
            },
            mouseLeave() {
                this.flag = false
            },
            resetScreenSize(dw, dh) {
                if (window.innerWidth > 1000) {
                    function init() {
                        var _el = document.getElementById('cloudCenter');
                        var hScale = window.innerHeight / (dh || 1080);
                        var wScale = window.innerWidth / (dw || 1920);
                        _el.style.transform = 'scaleX(' + wScale + ') scaleY(' + hScale + ')'
                    }

                    var lazyFun;
                    window.onresize = function () {
                        clearTimeout(lazyFun);
                        lazyFun = setTimeout(function () {
                            init()
                        }, 600)
                    }
                    init()
                }
            }
        }
    }
</script>

<style scoped>
    #cloudCenter {
        width: 1920px;
        height: 1080px;
        transform-origin: left top;
        position: relative;
    }

    .bthover {
        width: 1920px;
        height: 20px;
        position: absolute;
        background: none;
        bottom: 0;
    }

    .route_box {
        margin-top: -30px;
        height: 50px;
        display: flex;
        align-items: center;
        background: rgba(0, 0, 0, 0.4);
        font-family: "Microsoft YaHei";
    }

    .gopage_box {
        display: flex;
        align-items: center;
        margin-left: 40px;
        cursor: pointer;
    }

    .gopage_box div {
        color: #FFFFFF;
        margin-left: 10px;
        font-size: 16px;
    }

    /deep/ .el-tooltip__popper {
        font-family: "Microsoft YaHei";
    }
</style>
